const amber = {
  100: '#FFAA00'
};

export { amber };
